module.exports = __webpack_public_path__ + "img/acomerclub.66cce435.jpg";